<template>
	<div class="articledetails">
		<div class="articledetails-div">
			<div class="left">
				<div  style="width: 100%; background-color: #FFFFFF; padding-bottom: 2rem;box-shadow: 0 0 10px #bfbfbf;	border-radius: 0.3rem;">
					<div class="left-div">
						<div class="title">{{info.title}}</div>
						<div class="top">
							<div class="div1">
								
								<img :src="avatar|Ximgurl" />
								<div>{{info.three ? info.three.username : '总办方'}}</div>
							</div>
							<div style="width: 9rem;">
								<img src="../../assets/shudo/images/u2464.png" />
								<div style="width: 9rem;" >{{info.create_time}}</div>
							</div>
							<div @click="like(info.id)">
								<img src="../../assets/shudo/images/u2465.png" />
								<div>{{info.like}}</div>
							</div>
							<div @click="collect(info.id)">
								<img src="../../assets/shudo/images/u2466.png" />
								<div>{{info.collect}}</div>
							</div>
						</div>
						<div class="body" v-html="info.details">
						</div>
						<div style="text-align: right;line-height: 6rem; color: #7F7F7F;" @click="iscussAdd(info.id,0)">
							<img style="width: 1.2rem;position: relative;top: 0.3rem;" src="../../assets/shudo/images/u1231.png" />
							<span style="padding-left: 0.3rem;">评论</span>
						</div>
						
						<div class=""></div>
					</div>
				</div>
				<div class="qdetails-conent">
					
					<div class="qdetails-conent-left">
						<div class="qdetails-conent-left-title">
							<div>评论（{{count}})</div>
						</div>
						
						<div v-for="(item,index) in iscuss" :key="index" v-if="iscuss.length > 0">
							<div class="qdetails-conent-left-div" >
								<div class="title">
									<div class="left">
										<div class="left1">
											<img src="../../assets/shudo/images/8.svg" />
										</div>
										<div class="right1">
											<div>{{item.user? item.user.username: '匿名'}}</div>
											<!-- <div>{{item.user.username}}</div> -->
											<div style="font-weight: 600; color: #8a8a8a;">来自 {{info.title}}</div>
										</div>
									</div>
									<div class="right">
										{{item.create_time}}
									</div>
								</div>
								<div class="conent">
									{{item.body}}
								</div>
								<div class="conent">
									<div class="conent-left" @click="iscussAdd(info.id,item.id)">
										<img src="../../assets/shudo/images/u1231.png" />
										<span>回复</span>
									</div>
									<div class="conent-right" @click="discussuser(item.id)">
										<img src="../../assets/shudo/images/u1225.svg" />
										<span>赞同{{item.count}}</span>
									</div>
								</div>
							</div>
							<div class="qdetails-conent-left1" v-for="(it,ind) in item.child" :key="ind" v-if="item.child.length > 0">
								<div class="qdetails-conent-left-div">
									<div class="title">
										<div class="left">
											<div class="left1">
												<img src="../../assets/shudo/images/8.svg" />
											</div>
											<div class="right1">
												<div>{{it.user? it.user.username: '匿名'}}</div>
												<div>
													<span style="font-weight: 600; color: #8a8a8a;padding-right: 0.3rem;"> 来自 {{info.title}}</span>的评论
												</div>
											</div>
										</div>
										<div class="right">
											{{it.create_time}}
										</div>
									</div>
									<div class="conent">
										{{it.body}}
									</div>
									<div class="conent">
										<!-- <div class="conent-left">
											<img src="http://jinbangsai.net/shudu/images/%E9%A2%98%E5%BA%93%E8%AF%A6%E6%83%85/u1231.png" />
											<span>回复</span>
										</div> -->
										<div class="conent-right" @click="discussuser(it.id)">
											<img src="../../assets/shudo/images/u1225.svg" />
											<span>赞同{{it.count}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						
					</div>
				</div>
			</div>
			<div class="right">
				<div class="conent1">
					<div class="conont-title">
						<div>作者信息</div>
					</div>
					<div class="conont-title1">
						<img :src="avatar|Ximgurl" />
					
						<div>
							<div class="title1">{{info.three ? info.three.username : '总办方'}}</div>
							<div class="title2">中国|杭州</div>
						</div>
						<div class="guanzhu" @click="merchantuseradd()">关注</div>
					</div>
					<div class="conont-title2">
						{{info.brief}}
					</div>
				</div>
				
				<div class="sign">
					<div class="sign-div">
						<div>加入圈子</div>
						<div>QQ群|微信群</div>
					</div>
					<div class="sign-div1" v-for="(item,index) in wxchat" :key="index">
						<div class="sign-left">
							<img :src="item.img|Ximgurl" />
						</div>
						<div class="sign-conent">{{item.name}}</div>
						<div class="sign-right" @click="join(item.type,item.number)">加入</div>
					</div>
				</div>
				<!-- 热门文章 -->
				<div class="sign">
					<div class="sign-div">
						<div>热门文章</div>
						<div><router-link to="/article/list">更多</router-link></div>
					</div>
				
					<div class="sign-div2"  v-for="(item,index) in articlehotlist" :key="index" @click="article(item.id)">
					
						<div class="sign-left">
							<img :src="item.img|Ximgurl" />
						</div>
						<div class="sign-conent">
							<div>{{item.title}}</div>
							<div>{{item.create_time}}</div>
						</div>
					
					</div>
				
				</div>
			</div>
		</div>
		
		
		
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				info  : [],
				avatar : '',
				articleuser:[],
				wxchat : [],
				iscuss : [],
				count  : 0
				
			
			}
		},
		
	    created() {
			let that    = this;
			var  query = this.$route.query;
			this.getlist();
			if(query.id){
				that.infoList(query.id);
			}
		
	    },
		methods:{
			discussuser(discuss_id){
				let that = this;
				that.$http('post','/api/v1/iscuss/discussuseradd',{'discuss_id':discuss_id}) .then(function (res) {
					if(res.code==200){
						that.infoList(that.info.id);
						that.$message({ showClose: true,message: res.msg,type: 'success'});
					}else{
						that.$message({ showClose: true,message: res.msg,type: 'error'});
					}
				});
			},
			like(id){  //喜欢
				let that = this;
				
				that.$http('post','/api/v1/article/typeadd',{'article_id':id,'type':0}) .then(function (res) {
					if(res.code==200){
						that.infoList(id);
						that.$message({ showClose: true,message: res.msg,type: 'success'});
					}else{
						that.$message({ showClose: true,message: res.msg,type: 'error'});
					}
					console.log(res);
				});
				console.log(id);
			},
			collect(id){  //收藏
				let that = this;
				that.$http('post','/api/v1/article/typeadd',{'article_id':id,'type':1}) .then(function (res) {
					if(res.code==200){
						that.infoList(id);
						that.$message({ showClose: true,message: res.msg,type: 'success'});
					}else{
						that.$message({ showClose: true,message: res.msg,type: 'error'});
					}
					console.log(res);
				});
			},
			join(type,number){   //联系方式
				let that = this;
				type = type == 0 ? '微信' : 'QQ'; 
				that.$alert(type+':'+number, '联系方式', {
				    confirmButtonText: '确定',
				    callback: action => {
				      
				    }
				});
				console.log(number);
			},
			iscussAdd(id,pid){
				let that = this;
				that.$prompt('请输入评论内容', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
			
				}).then(({ value }) => {
					that.$http('post','/api/v1/iscuss/add',{'id':id,'type':0,'body':value,'pid':pid}) .then(function (res) {
						if(res.code==200){
							that.infoList(id);
							that.$message({ showClose: true,message: res.msg,type: 'success'});
						}else{
							that.$message({ showClose: true,message: res.msg,type: 'error'});
						}
						console.log(res);
					});
				});
			},
			merchantuseradd(){  //关注
				let that = this;
				
				if(that.info.type==0){
					
					that.$http('post','/api/v1/merchant/merchantuseradd',{merchant_id: that.info.three_id,type:0}) .then(function (res) {  //关注
						that.$message({type: 'info',message: '操作成功',type: 'success'});   
						console.log(res);
					});
				}else if(that.info.type==1){
					
					that.$http('post','/api/v1/sponsor/add',{sponsor_id:that.info.three_id,type:0}) .then(function (res) {  //关注
						that.$message({type: 'info',message: '操作成功',type: 'success'});   
						console.log(res);
					});
				}
				
			},
			infoList(id){
				let that = this;
				that.$http('get','/api/v1/article/details',{'id':id}) .then(function (res) {
					that.info   = res.data.info;	
					that.avatar = res.data.info.three ? res.data.info.three.avatar : '/uploads/8.svg' ;
					
					that.articleuser = res.data.articleuser;	
				});
				that.$http('get','/api/v1/iscuss/list',{type:0,three_id:id}) .then(function (res) {  //评论列表
					that.iscuss  = res.data.list;
					that.count   = res.data.count;
					console.log(res.data);
				});
			},
			article(id){
				this.id = id;
				this.infoList(id);
			},
			getlist(){
				let that = this;
				
				that.$http('get','/api/v1/wxchat',{}) .then(function (res) {  //联系方式
					that.wxchat = res.data;
				});
				that.$http('get','/api/v1/article/hotlist',{}) .then(function (res) {  //文章列表
					that.articlehotlist  = res.data.list;
					
				});
			
			},
			
		}
		
	}	
</script>

<style lang="less">
	.articledetails {
		background-color: rgb(242, 242, 242);
		width: 100%;
		min-height: 100vh;
		.articledetails-div{
			width: 81.25rem;
			margin: auto;
			margin-top: 2rem;
			display: flex;
			padding-bottom: 2rem;
			
			.left {
				
				min-height: 10rem;
				// flex: 5;
				width: 62.75rem;
				padding-bottom: 2rem;
				margin-right: 2rem;
				.left-div {
					
					width: 90%;
					padding-top: 1rem;
					margin: auto;
					.title {
						font-size: 1rem;
					}
					.top {
						display: flex;
							color: #A4A1A6;
						div {
							width: 5rem;
							display: flex;
							margin-left: 0.4rem;
							height: 2rem;
							line-height: 3rem;
							font-size: 0.6rem;
							img {
								position: relative;
								top: 1rem;
								width: 1rem;
								height: 1rem;
								border-radius: 50px;
							}
						}
					}
					.body {
						margin-top: 0.6rem;
						font-size: 0.6rem;
						color: #A4A1A6;
					}
					
				}
				
			}
			.right {
				flex: 2;
				min-height: 10rem;
				.conent1 {
					min-height: 6rem;
					    box-shadow: 0 0 10px #bfbfbf;
					background-color: #FFFFFF;
					.conont-title {
						line-height: 2rem;
						
						height: 2rem;
						color: #7F7F7F;
						font-size: 0.6rem;
						border-bottom:  1px solid #7f7f7fad;
						div {
							width: 4rem;
							padding-left: 0.6rem;
							border-bottom: 2px solid #d9001b;
						}
					}
					.conont-title1 {
						display: flex;
						height: 4rem;
						img {
							margin-top: 0.8rem;
							margin-left: 1rem;
							width: 2.5rem;
							height: 2.5rem;
						}
						div {
							padding-left: 0.4rem;
							color: #7F7F7F;
							// padding-top: 0.7rem;
							.title1 {
								padding-top: 0.9rem;
								font-size: 1rem;
							}
							.title2 {
								font-size: 0.6rem;
							}
						}
						.guanzhu {
							padding: 0;
							margin-left: 1rem;
							width: 3rem;
							line-height: 1.2rem;
							text-align: center;
							border-radius: 0.8rem;
							margin-top: 1.3rem;
							height: 1.2rem;
							border: 1px solid;
							font-size: 0.6rem;
						}
					}
					.conont-title2 {
						width: 90%;
						margin: auto;
						color: #7F7F7F;
						text-indent:2em;
						padding-bottom: 2rem;
						font-size: 0.6rem;
					}
				}
				.sign {
					box-shadow:0 0 10px #bfbfbf;
					margin-top: 1rem;
					width: 100%;
					background-color: #FFFFFF;
					min-height: 5rem;
					padding-bottom: 1rem;
					.sign-div {
						width: 95%;
						margin-left: auto;
						margin-right: auto;
						line-height: 25px;
						display: flex;
						font-size: 0.5rem;
						border-bottom: 1px solid #999393;
						div:nth-last-child(2){
							height: 1.6rem;
							border-bottom: 0.2rem solid rgba(217, 0, 27, 1);
						}
						div:nth-last-child(1){
							font-size: 0.875rem;
							margin-left: auto;
							padding-right: 0.4rem;
							line-height: 1.8rem;
							color: #bcadab;
						}
					}
					.sign-div1 {
						width: 100%;
						display: flex;
						margin-top: 0.2rem;
						font-size: 0.6rem;
						color:  rgba(217, 0, 27, 1);
						
						.sign-div1-left {
							width: 46%;
							border: 1px solid rgba(217, 0, 27, 1);
							margin-left: 1rem;
							border-radius: 0.3rem;
							margin-top: 10px;
						
							display: flex;
							height: 1.4rem;
							line-height: 1.4rem;
							img {
								padding-top: 0.1rem;
								padding-left: 0.2rem;
								width: 1rem;
								height: 1rem;
							}
							span{
								padding-left: 0.4rem;
							}
						}
						.sign-div1-right {
							width: 20%;
							
							margin-left: 2rem;
							border-radius: 0.3rem;
							border: 1px solid rgba(217, 0, 27, 1);
							margin-top: 10px;
							display: flex;
							height: 1.4rem;
							line-height: 1.4rem;
							span{
								display: block;
								padding-left: 0.6rem;
								text-align: center;
							}
						}
						.sign-left {
							flex: 1;
							height: 1.6rem;
							img{
								display: block;
								margin: auto;
								width: 20px;
								height: 20px;
								
							}
						}
						.sign-conent {
							flex: 3;
							color: #333333;
							height: 1.6rem;
							line-height: 1.6rem;
						}
						.sign-right {
							margin-right: 0.4rem;
							margin-top: 0.2rem;
							width: 2.4rem;
							text-align: center;
							border: 1px solid;
							height: 1rem;
							color: #333333;
							border-radius: 3px;
							
						}
					}
					.sign-div2 {
						width: 100%;
						display: flex;
						margin-bottom: 0.2rem;
						margin-top: 0.2rem;
						font-size: 0.6rem;
						min-height: 3rem;
						color:  rgba(217, 0, 27, 1);
						
						.sign-left {
							flex: 1;
							height: 1.6rem;
							img{
								display: block;
								margin: auto;
								width: 45px;
								height: 40px;
							}
							img:hover{transform: scale(1.1);}
						}
						.sign-conent {
							flex: 3;
							color: #333333;
							
							div:nth-last-child(2){
								font-size: 0.4rem;
								color: #555555;
								height: 2rem;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 2; //行数
								-webkit-box-orient: vertical;
								padding-right: 0.5rem;
							}
							div:nth-last-child(1){
								color: #555555cc;
								
							}
						}
					}
					
					
					.sign-div3 {
						width: 90%;
						display: flex;
						margin: auto;
						margin-top: 0.2rem;
						height: 2.6rem;
						font-size: 0.6rem;
						color:  rgba(217, 0, 27, 1);
						border-bottom: 1px solid #999393;
						.sign-left {
							flex: 1;
							height: 1.6rem;
							img{
								display: block;
								margin: auto;
								width: 30px;
							}
						}
						.sign-conent {
							flex: 3;
							color: #333333;
							
							div:nth-last-child(2){
								font-size: 0.4rem;
								color: #555555;
							}
							div:nth-last-child(1){
								color: #555555cc;
								display: flex;
								
							}
						}
					}
				
				}
				
				
				
			}
		}
		
		
		.qdetails-conent {
			margin-top: 1rem;
			width: 100%;
			background-color: #FFFFFF;
			min-height: 6rem;
			padding-bottom: 0.5rem;
			color: #7F7F7F;
			border-radius: 0.3rem;
			box-shadow: 0 0 10px #bfbfbf;
			.qdetails-conent-left {
				width: 100%;
				// border-bottom: 1px solid #7f7f7f17;
				padding-bottom: 0.3rem;
				.qdetails-conent-left-title {
					width: 100%;
					line-height: 3rem;
					height: 3rem;
					border-bottom: 1px solid #7F7F7F ;
					div {
						width: 4.2rem;
						margin-left: 1rem;
						padding-left: 0.2rem;
						font-weight: 600;
						border-bottom: 0.2rem solid rgba(217, 0, 27, 1);
					}
				}
				.qdetails-conent-left-div {
					width: 96%;
					margin: auto;
					margin-top: 0.8rem;
					min-height: 3.5rem;
					padding-top: 1rem;
					.title {
						width: 100%;
						display: flex;
						height: 2rem;
						.left {
							display: flex;
							.left1 {
								width: 2rem;
								img {
									width: 100%;
								}
							}
							.right1 {
								margin-left: 0.5rem;
								line-height: 1rem;
								font-size: 0.6rem;
							}
						}
						.right {
							font-size: 0.6rem;
							margin-left: auto;
						}
					}
					.conent {
						padding-top: 0.5rem;
						min-height: 1rem;
						font-size: 0.6rem;
						margin-left: 2.5rem;
						display: flex;
						.conent-left {
							img{
								width: 1rem;
								position: relative;
								top: 0.2rem;
							}
							span {
								padding-left: 0.6rem;
							}
						}
						.conent-right{
							margin-left: auto;
							padding-right: 3rem;
							img {
								position: relative;
								top: 0.1rem;
							}
							span {
								padding-left: 0.4rem;
							}
						}
					}
				}
				
			}
			
			.qdetails-conent-left1 {
				width: 100%;
				border-bottom: 1px solid #7f7f7f17;
				padding-bottom: 0.3rem;
				.qdetails-conent-left-div {
					width: 96%;
					margin: auto;
					margin-top: 0.8rem;
					min-height: 3.5rem;
				
					.title {
						width: 100%;
						display: flex;
						height: 2rem;
						.left {
							display: flex;
							margin-left: 2rem;
							.left1 {
								width: 2rem;
								img {
									width: 100%;
								}
							}
							.right1 {
								margin-left: 0.5rem;
								line-height: 1rem;
								font-size: 0.6rem;
							}
						}
						.right {
							font-size: 0.6rem;
							margin-left: auto;
						}
					}
					.conent {
						padding-top: 0.5rem;
						min-height: 1rem;
						font-size: 0.6rem;
						margin-left: 4.5rem;
						
						display: flex;
						.conent-left {
							img{
								width: 1rem;
								position: relative;
								top: 0.2rem;
							}
							span {
								padding-left: 0.6rem;
							}
						}
						.conent-right{
							margin-left: auto;
							padding-right: 3rem;
							img {
								position: relative;
								top: 0.1rem;
							}
							span {
								padding-left: 0.4rem;
							}
						}
					}
				}
				
			}
			
			.qdetails-conent-right {
				width: 100%;
				
				.qdetails-conent-right1 {
					width: 100%;
					display: flex;
					border-bottom: 1px solid #7f7f7f17;
					.qdetails-conent-right-div {
						width: 33%;
						display: flex;
						
						height: 6.9rem;
						
						.dss {
							width: 85%;
							margin: auto;
							display: flex;
							height: 4rem;
							border-right: 1px solid #7f7f7f17;
							margin-top: 1.5rem;
							img {
								width: 2rem;
								height: 2rem;
							}
							.div {
								padding-left: 0.2rem;
								font-size: 0.6rem;
								line-height: 1rem;
								span{
									padding: 0.2rem;
								}
								span:nth-last-child(2){
									font-weight: 600;
								}
							}
							.div1 {
								padding-left: 0.2rem;
								font-size: 0.6rem;
								line-height: 1.5rem;
								
								span{
									padding: 0.2rem;
								}
								span:nth-last-child(1){
									font-weight: 600;
								}
							}
							.div2 {
								line-height: 1.6rem;
								padding-left: 0.2rem;
								font-size: 0.6rem;
							}
						}
						
						
					}
				}
				
			}
		}
	}
	
</style>
